import { useRef} from 'react'
import { RhyBusPageHeader } from '@rhybus/header'
import { RhyBusSiteFeedback, SiteFeedbackRef, SiteFeedbackData } from '@rhybus/site-feedback'
import { saveSiteFeedbackItem } from '../../services/siteFeedback'
import { feedbackFieldsConfig } from '../../config/configuration'

export default function SiteFeedback() {
    const feedbackRef = useRef<SiteFeedbackRef>(null)
    const handleSubmit = async (data: SiteFeedbackData) => {
        try {
            feedbackRef.current?.setLoading(true)
            await saveSiteFeedbackItem(data)
            feedbackRef.current?.setLoading(false)
            feedbackRef.current?.setSuccess(true)
            feedbackRef.current?.reset()
            setTimeout(() => {
                feedbackRef.current?.setSuccess(false)
            }, 3000)
        } catch (error) {
            console.error('Error submitting site feedback:', error)
            feedbackRef.current?.setLoading(false)
        }
    }
    const handleClear = () => {
        feedbackRef.current?.reset()
    }
    return (
        <main id="main-content">
            <RhyBusPageHeader pageTitle={'Site Feedback'} pageHeaderIcon="icon-rb-site-feedback" />
            <div className="container">
                <div className="row">
                    <div className="col-12 mt-0">
                        <RhyBusSiteFeedback
                            ref={feedbackRef}
                            cardSize='lg'
                            title="Please let us know how we can make this site more useful to you"
                            fieldsConfig={feedbackFieldsConfig}
                            submitLabel="Submit"
                            clearLabel="Clear"
                            onSubmit={handleSubmit}
                            onClear={handleClear}
                        />
                    </div>                   
                </div>
            </div>
        </main>
    )
}